module.exports = __webpack_public_path__ + "static/media/img5.53adae39.jpg";